import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
// import PageMeta from '../partials/PageMeta';
// import PageHeading from '../partials/PageHeading';
import DocChannelLogo from '../icons/logos/DocChannel';
import CMFLogo from '../icons/logos/CMF';
import CatbirdLogo from '../icons/logos/Catbird';

import styles from '../../../styles/pages/credits.scss';

// const messages = defineMessages({
//     button: {
//         id: 'content.credits_button',
//         defaultMessage: 'Full Website Credits',
//     },
// });

const propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            section: PropTypes.string,
            position: PropTypes.string,
            names: PropTypes.arrayOf(PropTypes.string),
        }),
    ),
};

const defaultProps = {
    className: null,
    items: [
        {
            section: 'main',
            position: 'website producers',
            names: ['Kathy Sperberg', 'Isabelle Couture'],
        },
        {
            section: 'main',
            position: 'content producer',
            names: ['Kathy Sperberg'],
        },
        {
            section: 'main',
            position: 'digital marketing & community outreach',
            names: ['Kathy Sperberg'],
        },
        {
            section: 'main',
            position: 'catbird productions',
            names: ['Katarina Soukup \xa0 | \xa0 Isabelle Couture \xa0|\xa0 Justine Pignato'],
        },
        {
            section: 'main',
            position: 'gobez media',
            names: ['Tamara Dawit'],
        },
        {
            section: 'main',
            position: 'social media & online engagement',
            names: [
                'Ring Five Impact Docs',
                'Jackie Garrow\xa0 | \xa0Impact Producer',
                'Carla Rojas \xa0| \xa0Social Media Manager',
                'Rebecca Fisseha \xa0|\xa0 Community manager',
                'Alessandra Hechanova \xa0|\xa0 Designer',
                'Victoria Stern \xa0|\xa0 Outreach Researcher',
            ],
        },
        {
            section: 'main',
            position: 'publicity',
            names: ['Ingrid Hamilton \xa0|\xa0 GAT PR', 'Macy Armstrong \xa0|\xa0 GAT PR'],
        },
        {
            section: 'main',
            position: 'distribution - Canada',
            names: ['Cinema Politica'],
        },
        {
            section: 'main',
            position: 'world sales',
            names: ['Rise & Shine'],
        },
        {
            section: 'website',
            names: ['Dominic Turmel', 'Raymond Deblois'],
        },
        {
            section: 'website',
            position: 'finding sally title design',
            names: ['Kevin Lo \xa0|\xa0 LOKI DESIGN'],
        },
        {
            section: 'website',
            position: 'web developer',
            names: [
                'David Mongeau-Petitpas \xa0|\xa0 Folklore',
                'Brandon Tam \xa0|\xa0 Folklore',
                'Jessica Johnson \xa0|\xa0 Folklore',
            ],
        },
        {
            section: 'website',
            position: 'post-production supervisor (Film)',
            names: ['Julien Tremblay', 'Mélanie Gauthier'],
        },
        {
            section: 'website',
            position: 'post-production coordinator (Film)',
            names: ['Marie-Pier Dupuis'],
        },
        {
            section: 'music',
            position: 'original music',
            names: ['Zaki Ibrahim', 'Abegasu Shiota'],
        },
        {
            section: 'stories',
            position: 'writer',
            names: ['Tamara Mariam Dawit'],
        },
        {
            section: 'stories',
            position: 'story advisors',
            names: ['Isabelle Couture', 'Kathy Sperberg'],
        },
        {
            section: 'stories',
            position: 'video editor',
            names: ['Tamara Scherbak'],
        },
        {
            section: 'stories',
            position: 'video editor \xa0|\xa0 social media capsules',
            names: ['Tamara Scherbak'],
        },
        {
            section: 'stories',
            position: 'additional writers',
            names: ['David Eng', 'Leul Shoaferaw'],
        },
        {
            section: 'micro-stories',
            position: 'DIGITAL CREATIVE PRODUCER',
            names: ['Kathy Sperberg'],
        },
        {
            section: 'micro-stories',
            position: 'WRITER',
            names: ['TAMARA MARIAM DAWIT'],
        },
        {
            section: 'micro-stories',
            position: 'ADDITIONAL WRITER',
            names: ['KATHY SPERBERG'],
        },
        {
            section: 'micro-stories',
            position: 'MICRO-STORIES | VIDEO EDITOR',
            names: ['JULES DE NIVERVILLE'],
        },
        {
            section: 'micro-stories',
            position: 'MICRO-COLLAGES | CREATIVE DIRECTION | GRAPHIC DESIGNER',
            names: ['PABLO PARRA'],
        },
        {
            section: 'micro-stories',
            position: 'VOICE-OVER NARRATOR',
            names: ['TAMARA MARIAM DAWIT'],
        },
        {
            section: 'micro-stories',
            position: 'RECORDING STUDIO',
            names: ['BEDTRACKS'],
        },
        {
            section: 'micro-stories',
            position: 'VISUAL RESEARCHERS',
            names: ['LEUL SHOAFERAW', 'KATHY SPERBERG'],
        },
        {
            section: 'micro-stories',
            position: 'ORIGINAL MUSIC',
            names: ['ZAKI IBRAHIM', 'ABEGASU SHIOTA'],
        },
        {
            section: 'micro-stories',
            position: 'SOUND DESIGN AND MIX',
            names: ['BENOÎT DAME', 'JÉRÉMIE JONES'],
        },
        {
            section: 'capsules',
            position: 'art direction',
            names: ['Dominic Turmel', 'Raymond Deblois'],
        },
        {
            section: 'capsules',
            position: 'voice-over director',
            names: ['Faisal Lutchmedial'],
        },
        {
            section: 'capsules',
            position: 'scriptwriter \xa0|\xa0 researcher',
            names: ['Zahra Moloo'],
        },
        {
            section: 'capsules',
            position: 'story advisors',
            names: ['Bridget Conley', 'Tamara Mariam Dawit'],
        },
        {
            section: 'capsules',
            position: 'additional story consultant',
            names: ['Alex de Waal'],
        },
        {
            section: 'capsules',
            position: 'voice-over narrator',
            names: ['REHASET'],
        },
        {
            section: 'capsules',
            position: 'recording studio',
            names: ['REDLAB \xa0|\xa0 PREMIUM SOUND'],
        },
        {
            section: 'capsules',
            position: 'motion graphics director',
            names: ['Faisal Lutchmedial'],
        },
        {
            section: 'capsules',
            position: 'visual researchers',
            names: [
                'Dominic Turmel',
                'Leul Shoaferaw',
                'Tamara Mariam Dawit',
                'Pamela Grimaud',
                'Kathy Sperberg',
            ],
        },
        {
            section: 'capsules',
            position: 'sound design',
            names: ['Catherine Van De Donkt \xa0|\xa0 Benoît Dame \xa0|\xa0 Jérémie Jones'],
        },
        {
            section: 'capsules',
            position: 'mix',
            names: ['Benoît Dame'],
        },
        {
            section: 'capsules',
            position: 'colourist \xa0|\xa0 online editor',
            names: ['Tamara Scherbak'],
        },
        {
            section: 'articles',
            names: [
                'Zarha Moloo',
                'Haben Fecadu \xa0|\xa0 Amnesty International',
                'Bridget Conley',
                'Fanaye Gebrehiwot \xa0|\xa0 Tamara Mariam Dawit',
                'Menbie Dawit \xa0|\xa0 Tamara Mariam Dawit',
            ],
        },
        {
            section: 'articles',
            position: 'web copywriters',
            names: [
                'Leul Shoaferaw',
                'David Eng',
                'Tamara Mariam Dawit',
                'Zarha Moloo',
                'Kathy Sperberg',
                'Isabelle Couture',
            ],
        },
        {
            section: 'articles',
            position: 'copy editor',
            names: ['David Eng'],
        },
        {
            section: 'articles',
            position: 'translations',
            names: ['Leul Shoaferaw', 'Ashu Kersma'],
        },
        {
            section: 'articles',
            position: 'legal',
            names: ['Vanessa Loubineau'],
        },
        {
            section: 'articles',
            position: 'accounting',
            names: ['Carol Ann Gregory'],
        },
        {
            section: 'articles',
            position: 'archives',
            names: [
                'ABREHET ASEFA',
                'ASSOCIATED PRESS',
                'THE CANADIAN PRESS',
                'THE DAWIT FAMILY',
                'EFOOTAGE',
                'ETHIOPIAN BROADCAST CORPORATION',
                'ETHIOPIAN PRESS AGENCY',
                'FERKETE GEBREMARIAM',
                'JOURNEYMAN PICTURES',
                'KINOLIBRARY',
                'LIBRARY AND ARCHIVES CANADA',
                'NETEB MEDIA',
                'THE RED TERROR MARTYRS MEMORIAL MUSEUM',
                'SCREENOCEAN (REUTERS)',
                'Archives Research and Clearance \xa0|\xa0 TERRI FOXMAN',
            ],
        },
        {
            section: 'articles',
            position: 'additional visual sources',
            names: [
                'ETHIOPIA FEDERAL POLICE',
                'Keystone Pictures USA/ZUMAPRESS',
                'NATASHA SINEGINA I creazilla.com I DESIGNED BY CREAZILLA',
            ],
        },
        {
            section: 'thankyou',
            // position: 'thank you',
            names: [
                'Abrehet Asefa',
                'Ashu Kersma',
                'Bridget Conley',
                'Brutawit Dawit',
                'Elleni Centime Zeleke',
                'Ferkete Gebremariam',
                'Kibre Dawit',
                'Menbere Dawit',
                'Mulugeta Gebrehiwit',
                'Reeyot Alemu',
                'Sankofa Video, Books & Café',
                'Tsion Dawit',
            ],
        },

        {
            section: 'financial',
            position: 'Produced with the financial participation of',
        },
        {
            section: 'doc',
            position: 'Produced in association with',
        },
    ],
};

// const sections = {
//     main: '',
//     website: 'Website Art Direction',
//     interactive: 'Interactive Module',
//     stories: 'Digital Stories',
//     capsules: 'Ethiopia 101 Video Capsules',
//     articles: 'Written Articles',
//     thankyou: 'Thank you',
// };
//

const Credits = ({ items, className }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <h4 className={styles.title}>Credits</h4>
                <h4 className={styles.subtitle}>Digital Media &nbsp;|&nbsp; Outreach Campaign</h4>
                <div className={styles.credits}>
                    <dl>
                        {items.map(({ section, position, names }) => (
                            <>
                                {section === 'main' ? (
                                    <Fragment key={`credit-${position}`}>
                                        <dt className={styles.position}>{position}</dt>
                                        <dd className={styles.names}>
                                            <ul>
                                                {names.map((name) => (
                                                    <li key={`credit-${position}-${name}`}>
                                                        {name}
                                                    </li>
                                                ))}
                                            </ul>
                                        </dd>
                                    </Fragment>
                                ) : null}
                            </>
                        ))}
                        <div className={styles.section}>Website Art Direction</div>
                        {items.map(({ section, position, names }) => (
                            <>
                                {section === 'website' ? (
                                    <Fragment key={`credit-${position}`}>
                                        <dt className={styles.position}>{position}</dt>
                                        <dd className={styles.names}>
                                            <ul>
                                                {names.map((name) => (
                                                    <li key={`credit-${position}-${name}`}>
                                                        {name}
                                                    </li>
                                                ))}
                                            </ul>
                                        </dd>
                                    </Fragment>
                                ) : null}
                            </>
                        ))}
                        <div className={styles.section}>Original Music</div>
                        {items.map(({ section, position, names }) => (
                            <>
                                {section === 'music' ? (
                                    <Fragment key={`credit-${position}`}>
                                        <dd className={styles.names}>
                                            <ul>
                                                {names.map((name) => (
                                                    <li key={`credit-${position}-${name}`}>
                                                        {name}
                                                    </li>
                                                ))}
                                            </ul>
                                        </dd>
                                    </Fragment>
                                ) : null}
                            </>
                        ))}
                        <div className={styles.section}>Digital Stories</div>
                        {items.map(({ section, position, names }) => (
                            <>
                                {section === 'stories' ? (
                                    <Fragment key={`credit-${position}`}>
                                        <dt className={styles.position}>{position}</dt>
                                        <dd className={styles.names}>
                                            <ul>
                                                {names.map((name) => (
                                                    <li key={`credit-${position}-${name}`}>
                                                        {name}
                                                    </li>
                                                ))}
                                            </ul>
                                        </dd>
                                    </Fragment>
                                ) : null}
                            </>
                        ))}
                        <div className={styles.section}>Digital Micro-Stories | Micro-Collages</div>
                        {items.map(({ section, position, names }) => (
                            <>
                                {section === 'micro-stories' ? (
                                    <Fragment key={`credit-${position}`}>
                                        <dt className={styles.position}>{position}</dt>
                                        <dd className={styles.names}>
                                            <ul>
                                                {names.map((name) => (
                                                    <li key={`credit-${position}-${name}`}>
                                                        {name}
                                                    </li>
                                                ))}
                                            </ul>
                                        </dd>
                                    </Fragment>
                                ) : null}
                            </>
                        ))}
                        <div className={styles.section}>Ethiopia 101 Video Capsules</div>
                        {items.map(({ section, position, names }) => (
                            <>
                                {section === 'capsules' ? (
                                    <Fragment key={`credit-${position}`}>
                                        <dt className={styles.position}>{position}</dt>
                                        <dd className={styles.names}>
                                            <ul>
                                                {names.map((name) => (
                                                    <li key={`credit-${position}-${name}`}>
                                                        {name}
                                                    </li>
                                                ))}
                                            </ul>
                                        </dd>
                                    </Fragment>
                                ) : null}
                            </>
                        ))}
                        <div className={styles.section}>Written Articles</div>
                        {items.map(({ section, position, names }) => (
                            <>
                                {section === 'articles' ? (
                                    <Fragment key={`credit-${position}`}>
                                        <dt className={styles.position}>{position}</dt>
                                        <dd className={styles.names}>
                                            <ul>
                                                {names.map((name) => (
                                                    <li key={`credit-${position}-${name}`}>
                                                        {name}
                                                    </li>
                                                ))}
                                            </ul>
                                        </dd>
                                    </Fragment>
                                ) : null}
                            </>
                        ))}
                        <div className={styles.section}>Thank you</div>
                        {items.map(({ section, position, names }) => (
                            <>
                                {section === 'thankyou' ? (
                                    <Fragment key={`credit-${position}`}>
                                        <dt className={styles.position}>{position}</dt>
                                        <dd className={styles.names}>
                                            <ul>
                                                {names.map((name) => (
                                                    <li key={`credit-${position}-${name}`}>
                                                        {name}
                                                    </li>
                                                ))}
                                            </ul>
                                        </dd>
                                    </Fragment>
                                ) : null}
                            </>
                        ))}

                        <div className={styles.logoText}>
                            Produced with the financial participation of
                        </div>
                        <CMFLogo className={styles.logo} />

                        <div className={styles.logoText}>Produced in association with</div>
                        <DocChannelLogo className={styles.docLogo} />

                        <div className={styles.logoText}>Produced by</div>
                        <div className={styles.catbirdLogo}>
                            <CatbirdLogo className={styles.logo} />
                            <div className={styles.position}> © 2020</div>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    );
};

Credits.propTypes = propTypes;
Credits.defaultProps = defaultProps;

export default Credits;
